import Component from "@glimmer/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { on } from "@ember/modifier";
import { fn } from "@ember/helper";
import { i18n } from "discourse-i18n";
import DiscourseURL from "discourse/lib/url";

const avatarSize = 64;
const CSRF_TOKEN_COOKIE_KEY = "_csrf_token";

export default class WazeUserBox extends Component {
  @service currentUser;
  @service siteSettings;

  @action
  replaceWindowWithUserPage(page) {
    DiscourseURL.routeTo(
      `${this.siteSettings.waze_header_relative_url_root}u/${this.currentUser.username}${page}`,
    );
  }

  @action
  windowOpen(path) {
    window.open(path);
  }

  get avatarUrl() {
    const avatarTemplate = this.currentUser.avatar_template;
    return avatarTemplate.replace(/\{size\}/, avatarSize);
  }

  @action
  async handleLogout() {
    const currentUser = this.currentUser;
    if (!currentUser) {
      return;
    }
    // refresh the CSRF token and make sure it is `httpOnly: false`
    await fetch("/login/get");

    const lookup = `${CSRF_TOKEN_COOKIE_KEY}=`;
    const allCookies = document.cookie.split("; ");
    const cookie =
      allCookies.find((c) => c.startsWith(lookup))?.slice(lookup.length) ?? "";

    Promise.all([
      currentUser.destroySession(),
      // Destroys Waze session.
      fetch("/login/destroy", {
        method: "POST",
        headers: {
          "x-csrf-token": cookie,
        },
      }),
    ]).then(() => location.reload());
  }

  <template>
    {{#if this.currentUser}}
      <li class="wz-user-box">
        <wz-user-box
          class="wz-user-box"
          userName={{this.currentUser.username}}
          avatarUrl={{this.avatarUrl}}
          title={{this.currentUser.username}}
        >
          <wz-menu-title>
            {{i18n "waze.user_box.waze_discuss"}}
          </wz-menu-title>
          <wz-menu-item
            {{on "click" (fn this.replaceWindowWithUserPage "/summary")}}
          >
            {{i18n "waze.user_box.summary"}}
          </wz-menu-item>
          <wz-menu-item
            {{on "click" (fn this.replaceWindowWithUserPage "/activity")}}
          >
            {{i18n "waze.user_box.activity"}}
          </wz-menu-item>
          {{#if this.currentUser.can_invite_to_forum}}
            <wz-menu-item
              {{on
                "click"
                (fn this.replaceWindowWithUserPage "/invited/pending")
              }}
            >
              {{i18n "waze.user_box.invites"}}
            </wz-menu-item>
          {{/if}}
          <wz-menu-item
            {{on
              "click"
              (fn this.replaceWindowWithUserPage "/activity/drafts")
            }}
          >
            {{i18n "waze.user_box.drafts"}}
          </wz-menu-item>
          <wz-menu-item
            {{on
              "click"
              (fn this.replaceWindowWithUserPage "/preferences/account")
            }}
          >
            {{i18n "waze.user_box.preferences"}}
          </wz-menu-item>
          <wz-menu-divider></wz-menu-divider>
          <wz-menu-title>{{i18n "waze.user_box.general"}}</wz-menu-title>
          <wz-menu-item {{on "click" (fn this.windowOpen "/account")}}>
            {{i18n "waze.user_box.waze_account_settings"}}
          </wz-menu-item>
          <wz-menu-item {{on "click" (fn this.windowOpen "/help")}}>
            {{i18n "waze.user_box.help_center"}}
          </wz-menu-item>
          <wz-menu-item {{on "click" (fn this.windowOpen "/support")}}>
            {{i18n "waze.user_box.report_an_issue"}}
          </wz-menu-item>
          <wz-menu-item {{on "click" this.handleLogout}}>
            {{i18n "waze.user_box.logout"}}
          </wz-menu-item>
        </wz-user-box>
      </li>
    {{/if}}
  </template>
}
